import { render } from "./TasksView.vue?vue&type=template&id=e22945d6&scoped=true"
import script from "./TasksView.vue?vue&type=script&lang=js"
export * from "./TasksView.vue?vue&type=script&lang=js"

import "./TasksView.vue?vue&type=style&index=0&id=e22945d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22945d6"]])

export default __exports__